import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';
import { ClientKind, TinKind } from '@skylab-shared/dataModel';
import { Mutable } from '@skylab-shared/types';
import { PagedCollectionQueryResult } from '../../common/query/paged-collection-query';

export interface ClientsWithSameNameItem {
    readonly address: string;
    readonly city: string;
    readonly country: string;
    readonly favourite: boolean;
    readonly groupId: number;
    readonly id: number;
    readonly kind: ClientKind;
    readonly name: string;
    readonly tin: string;
    readonly tinKind: TinKind;
    readonly version: string;
    readonly zipCode: string;
}

export type ClientsWithSameTinQueryProperties = { tin: string; tinKind: string; omitedClientId?: number; };
export type ClientsWithSameNameQueryProperties = { exactName: string; omitedClientId?: number; };

export class ClientsWithSamePropertyQuery extends Query<ClientsWithSameNameItem[]> {
    public constructor(public readonly params: ClientsWithSameTinQueryProperties | ClientsWithSameNameQueryProperties) {
        super();
    }
}

export class ClientWithSamePropertyQueryHandlerBase implements QueryHandler<ClientsWithSamePropertyQuery, ClientsWithSameNameItem[]> {
    public static Url = TaggedUrl.join('clients', [Tags.Api, Tags.NotHandle404]);

    public constructor(
        private readonly http: HttpService,
    ) { }

    public async handleAsync(query: ClientsWithSamePropertyQuery): Promise<ClientsWithSameNameItem[]> {
        let items: ClientsWithSameNameItem[] = [];

        if (isTinQuery(query.params)) {
            const { data } = await this.http.get<Mutable<PagedCollectionQueryResult<ClientsWithSameNameItem>>>(ClientWithSamePropertyQueryHandlerBase.Url, {
                params: { tin: query.params.tin, tinKind: query.params.tinKind }
            });
            items = data?.items;
        } else {
            const { data } = await this.http.get<Mutable<PagedCollectionQueryResult<ClientsWithSameNameItem>>>(ClientWithSamePropertyQueryHandlerBase.Url, {
                params: { exactName: query.params.exactName }
            });
            items = data?.items;
        }

        if (items && query.params.omitedClientId) {
            return items.filter(x => x.id !== query.params.omitedClientId);
        }
        return items;
    }
}

const isTinQuery = (queryParams: ClientsWithSameTinQueryProperties | ClientsWithSameNameQueryProperties): queryParams is ClientsWithSameTinQueryProperties => {
    return (queryParams as ClientsWithSameTinQueryProperties).tin !== undefined;
};
